import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const AuthCtx = createContext({ authenticated: null, refresh: () => {}, logout: async () => {} });

export function AuthProvider({ children }) {
  const [authenticated, setAuthenticated] = useState(null); // null=checking, true/false

  const refresh = useCallback(async () => {
    try {
      const r = await api.get("/auth/me");
      setAuthenticated(!!r.data.authenticated);
    } catch {
      setAuthenticated(false);
    }
  }, []);

  const logout = useCallback(async () => {
    try { await api.post("/auth/logout"); } catch (e) { console.error("logout request failed:", e); /* non-fatal */ }
    setAuthenticated(false);
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  return (
    <AuthCtx.Provider value={{ authenticated, refresh, logout }}>
      {children}
    </AuthCtx.Provider>
  );
}

export function useAuth() { return useContext(AuthCtx); }
